export const updateTesting = (action)=>{
    return {
        type: "UPDATE_RANDOM_LOAD",
        payload: action
    }
};
